// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sk-9";
export var arrowButtonContainer = "_sk-5";
export var arrowButtonIcon = "_sk-6";
export var carouselArrowButton = "_sk-2";
export var carouselElementContainer = "_sk-1";
export var currentSlide = "_sk-8";
export var left = "_sk-3";
export var otherSlide = "_sk-a";
export var productCarouselContainer = "_sk-0";
export var right = "_sk-4";
export var sliderOverflow = "_sk-7";